import { Link, useLocation } from 'react-router-dom';

export default function Layout({ children }) {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#1A1C1F] flex flex-col font-sans antialiased selection:bg-[#FBF3DA] selection:text-[#1A1C1F]">
      {/* Top bar */}
      <header className="border-b border-[#E4E1D8] bg-[#FBFAF6] sticky top-0 z-20">
        <div className="max-w-[68ch] mx-auto px-4 h-14 flex items-center justify-between">
          <Link 
            to="/" 
            className="text-[19px] font-bold tracking-tight text-[#2E3A46] hover:text-[#B58200] transition-colors"
          >
            Trailerregler.dk
          </Link>
          <nav aria-label="Hovednavigation" className="text-[15px] font-medium text-[#5C636B] flex items-center gap-1.5 sm:gap-2">
            <Link 
              to="/koerekort-og-trailer" 
              className={`hover:text-[#2E3A46] hover:underline underline-offset-4 ${location.pathname === '/koerekort-og-trailer' ? 'text-[#2E3A46] font-semibold' : ''}`}
            >
              Kørekort
            </Link>
            <span className="text-[#E4E1D8] select-none" aria-hidden="true">·</span>
            <Link 
              to="/trailer-hastighed" 
              className={`hover:text-[#2E3A46] hover:underline underline-offset-4 ${location.pathname === '/trailer-hastighed' ? 'text-[#2E3A46] font-semibold' : ''}`}
            >
              Hastighed
            </Link>
            <span className="text-[#E4E1D8] select-none" aria-hidden="true">·</span>
            <Link 
              to="/trailer-syn" 
              className={`hover:text-[#2E3A46] hover:underline underline-offset-4 ${location.pathname === '/trailer-syn' ? 'text-[#2E3A46] font-semibold' : ''}`}
            >
              Syn &amp; plader
            </Link>
          </nav>
        </div>
      </header>

      {/* Centreret læsesøjle: max 68 tegn bredde */}
      <main className="flex-1 w-full max-w-[68ch] mx-auto px-4 py-8 sm:py-12">
        {children}
      </main>

      {/* Stilfærdig footer */}
      <footer className="border-t border-[#E4E1D8] bg-[#FBFAF6] mt-16 py-8 text-[14px] text-[#5C636B]">
        <div className="max-w-[68ch] mx-auto px-4 flex flex-col sm:flex-row items-baseline justify-between gap-4">
          <p className="m-0">
            Trailerregler.dk er en uafhængig informationsguide til færdselsregler for påhængskøretøjer i Danmark.
          </p>
          <div className="flex items-center gap-4 shrink-0 font-medium">
            <Link to="/om" className="text-[#5C636B] hover:text-[#2E3A46] hover:underline underline-offset-4">
              Om siden
            </Link>
            <span className="text-[#E4E1D8] select-none" aria-hidden="true">·</span>
            <Link to="/ordbog" className="text-[#5C636B] hover:text-[#2E3A46] hover:underline underline-offset-4">
              Ordbog
            </Link>
            <span className="text-[#E4E1D8] select-none" aria-hidden="true">·</span>
            <Link to="/trailer-regler" className="text-[#5C636B] hover:text-[#2E3A46] hover:underline underline-offset-4">
              Oversigt
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
